<template>
  <c-search-form :input-search-items="searchItems" :rows-per-page-items="[10,20,50]" :input-create-items="createItems"
                 :form-name="formName" :create-form-name="createFormName"
                 model="searchForm" :fields="fields" accept-copy
                 key-property="categoryId"
                 search-url="/category/listGrades"
                 create-url="/category/save"
                 delete-url="/category/delete">
  </c-search-form>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import axios from "axios";

export default {
  name: 'category-management',
  components: {CSearchForm},
  data: () => {
    return {
      formName: "lang.category.categoryManagement",
      createFormName: "lang.category.createCategory",
      categoryTypes: [],
      searchItems: [
        {
          type: "text",
          name: "categoryCode",
          label: "lang.category.code",
          placeHolder: "",
          focus: true
        },
        {
          type: "text",
          name: "categoryName",
          label: "lang.category.name",
          placeHolder: ""
        },
        {
          type: "select",
          name: "categoryTypeCode",
          itemText: "categoryTypeName",
          itemValue: "categoryTypeCode",
          items: [],
          label: "lang.category.categoryType",
          placeHolder: ""
        }
      ],
      createItems: [
        {
          type: "text",
          name: "categoryCode",
          label: "lang.category.code",
          validate: "required",
          maxlength: '50',
          placeHolder: "",
          errorText: "Lỗi"
        },
        {
          type: "text",
          name: "categoryName",
          label: "lang.category.name",
          validate: "required",
          maxlength: '250',
          placeHolder: ""
        },
        {
          type: "text",
          name: "description",
          label: "lang.category.description",
          validate: "required",
          maxlength: '250',
          placeHolder: ""
        },
        {
          type: "select",
          name: "categoryTypeCode",
          itemText: "categoryTypeName",
          itemValue: "categoryTypeCode",
          items: [],
          label: "lang.category.categoryType",
          validate: "required",
          maxlength: '250',
          placeHolder: ""
        }
      ],
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'categoryCode',
          text: 'lang.category.code',
          width: "10%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'categoryName',
          text: 'lang.category.name',
          width: "20%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'description',
          text: 'lang.category.description',
          width: "20%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'createAt',
          text: 'lang.common.create_at',
          width: "20%",
          sortable: false,
          dateFormat: 'dd/MM/yyyy hh:mm',
          headerStyle: "text-align:left"
        },
      ]
    }
  },

  created() {
    axios.post(process.env.VUE_APP_API_URL + "/category/listCategoryType").then(
        data => {
          this.createItems[3].items = data;
          this.searchItems[2].items = data;
        },
        error => {

        }
    )
  }
}
</script>
